const API_BASE_URL = "https://api.au-pair-gallery.de/api/v1";
export default API_BASE_URL;